export class SignInFacade {
    signIn;
    signInService;
    emailAddressFormat;
    signInCodeFormat;
    resendCountdown;
    pageNavigator;
    constructor(signIn, signInService, emailAddressFormat, signInCodeFormat, resendCountdown, pageNavigator) {
        this.signIn = signIn;
        this.signInService = signInService;
        this.emailAddressFormat = emailAddressFormat;
        this.signInCodeFormat = signInCodeFormat;
        this.resendCountdown = resendCountdown;
        this.pageNavigator = pageNavigator;
    }
    getSignIn() {
        return this.signIn;
    }
    async requestSignInCode(email) {
        if (this.signIn.isIdle()) {
            if (this.emailAddressFormat.isWellFormed(email)) {
                await this.sendFirstCode(email);
            }
            else {
                this.signIn.markInvalidEmail();
            }
        }
    }
    async verifySignInCode(code) {
        if (this.signIn.isIdleOnCodeStep() && this.signInCodeFormat.isComplete(code)) {
            this.signIn.markCheckingCode();
            try {
                const codeCheck = await this.signInService.checkCode(this.signIn.email.get(), code);
                this.applyCodeCheck(codeCheck);
            }
            catch {
                this.signIn.markUnavailable();
            }
        }
    }
    async resendSignInCode() {
        if (this.signIn.canRequestNewCode.get()) {
            this.signIn.markResendingCode();
            try {
                const codeRequest = await this.signInService.requestCode(this.signIn.email.get());
                this.applyResentCodeRequest(codeRequest);
            }
            catch {
                this.signIn.markUnavailable();
            }
        }
    }
    async submitSignInCode(code) {
        if (this.signIn.isCodeUsable.get()) {
            await this.verifySignInCode(code);
        }
        else {
            await this.resendSignInCode();
        }
    }
    chooseDifferentEmail() {
        if (this.signIn.isIdleOnCodeStep()) {
            this.resendCountdown.stop();
            this.signIn.returnToEmailStep();
        }
    }
    async sendFirstCode(email) {
        this.signIn.markSendingCode(email);
        try {
            const codeRequest = await this.signInService.requestCode(this.signIn.email.get());
            this.applyFirstCodeRequest(codeRequest);
        }
        catch {
            this.signIn.markUnavailable();
        }
    }
    applyFirstCodeRequest(codeRequest) {
        const resendAllowedAt = this.resendCountdown.findResendAllowedAt(codeRequest.secondsUntilResend);
        if (codeRequest.kind === 'sent') {
            this.signIn.markCodeSent(resendAllowedAt);
        }
        else {
            this.signIn.markTooManyCodes(resendAllowedAt);
        }
        this.resendCountdown.follow(this.signIn);
    }
    applyResentCodeRequest(codeRequest) {
        const resendAllowedAt = this.resendCountdown.findResendAllowedAt(codeRequest.secondsUntilResend);
        if (codeRequest.kind === 'sent') {
            this.signIn.markNewCodeSent(resendAllowedAt);
        }
        else {
            this.signIn.markTooManyCodes(resendAllowedAt);
        }
        this.resendCountdown.follow(this.signIn);
    }
    applyCodeCheck(codeCheck) {
        if (codeCheck.kind === 'signed-in') {
            this.signIn.markSignedIn();
            this.pageNavigator.navigateTo(codeCheck.redirectTo);
        }
        else {
            this.applyCodeRefusal(codeCheck);
        }
    }
    applyCodeRefusal(codeRefusal) {
        const resendAllowedAt = this.resendCountdown.findResendAllowedAt(codeRefusal.secondsUntilResend);
        if (codeRefusal.kind === 'wrong-code') {
            this.signIn.markWrongCode(codeRefusal.attemptsLeft, resendAllowedAt);
        }
        else if (codeRefusal.kind === 'code-expired') {
            this.signIn.markCodeExpired(resendAllowedAt);
        }
        else {
            this.signIn.markTooManyAttempts(resendAllowedAt);
        }
        this.resendCountdown.follow(this.signIn);
    }
}
//# sourceMappingURL=SignInFacade.js.map